import { Box, HStack, Icon, Text, VStack } from "components/ui";
import React from "react";

import { useUser } from "components/clerk";

declare global {
  interface Window {
    fcWidget?: any;
  }
}
import NotificationBadge from "components/ui/NotificationBadge";
import { Link, router, useNavigation, usePathname } from "expo-router";
import { Home, ListOrdered, MapPin, MessagesSquare, ShoppingCart } from "lucide-react-native";
import { useGetCartCurrentQuery } from "store/abcoApi";
import { useSiteSection } from "utils/hooks/useSiteSection";

const bottomTabs = [
	{
		icon: Home,
		label: "Home",
		href: "/",
	},
	{
		icon: MapPin,
		label: "My Sites",
		href: "/sites",
	},
	{
		icon: ListOrdered,
		label: "Orders",
		href: "/orders",
	},
	{
		icon: ShoppingCart,
		label: "Cart",
		href: "/cart",
		notification: {
			count: 3,
			color: "danger",
		},
	},
	{
		icon: MessagesSquare,
		label: "Chat",
		href: "#",
	},
];

const MobileBottomTabs = () => {
	const [activeTab, setActiveTab] = React.useState("Home");
	const navigation = useNavigation();
	const pathName = usePathname();
	const section = useSiteSection();
	const { isSignedIn } = useUser();

	const { data: cart, isLoading, isFetching, isError, error, currentData } = useGetCartCurrentQuery();
	const cartCount = cart?.lines?.length;
	if (pathName === "/cart" || pathName === "/dropdown") {
		return null;
	}

	if (!isSignedIn) {
		return null;
	}

	const cartNotificationBadge =
		cartCount && cartCount > 0 ? (
			<Box position="absolute" top={12} right={6} zIndex={3}>
				<NotificationBadge notificationCount={cartCount} notificationColor="danger" />
			</Box>
		) : null;

	return (
		<HStack
			alignContent="center"
			sx={{
				_android: {
					h: "$16",
				},
				"@md": { display: "none" },
				_ios: {
					marginBottom: 40,
				},
			}}
			backgroundColor="$primary"
			justifyContent="space-around"
			w="100%"
			px={6}
			role="navigation"
		>
			{bottomTabs.map((tab: any) => {
				const isActive = section === tab.href;
				const handlePress = () => {
					if (tab.href === "/cart") {
						router.push("/cart/(step1)/index");
					} else if (tab.label === "Chat") {
						// Open Freshchat widget
						if (typeof window !== 'undefined' && window.fcWidget) {
							window.fcWidget.open();
						}
					}
				};
				return (
					<Link href={tab.href} key={tab.label} onPress={handlePress}>
						<VStack position="relative" alignItems="center" py="$5" width={68}>
							{tab.notification && cartNotificationBadge}
							<Icon as={tab.icon} color={isActive ? "$darkteallight" : "$basicwhite"} size={"md"} />
							<Text size="xs" color={isActive ? "$darkteallight" : "$basicwhite"}>
								{tab.label}
							</Text>
						</VStack>
					</Link>
				);
			})}
		</HStack>
	);
};

export default MobileBottomTabs;
